export const appUrl = {
    getVenueByFilter: 'app-api/venue-pincode/',
    getBanners: 'app-api/banners/',
    getPromotions: 'app-api/promotions/',
    getNearByVenues: 'app-api/venue-filter/',
    getVenueDetails: 'app-api/venues/',
    getSports: 'app-api/sports/',
    getPincode: 'app-api/venue-pincode/',
    getVenueSlots: 'app-api/court-slots/',
    bookSlot: 'app-api/court-booking/',
    partialPaymentUrl: 'app-api/court-partial-booking-payment/',
    normalBookingUrl: 'app-api/court-booking-payment/',
    splitCourtPaymrntUrl: 'app-api/court-split-booking-payment/',
    AddonsURL: 'app-api/addons/',
    AddRating: 'app-api/add-rating/',
    getAllHomeVenues: 'app-api/all-home-venue-filter/'
}

export const accountUrl = {
    loginUrl: 'account-api/user-phone-login/',
    registrationUrl: 'account-api/user-phone-registration/',
    editprofileUrl: 'app-api/user-details/',
}

export const configURL = {
    generateOrderIdUrl: 'configuration-api/payment-order-id/',
    VenueDetails: 'configuration-api/venues/',
    otpSender: 'configuration-api/otp-sender/',
    slotPriceExtractor: 'configuration-api/slot-price-extractor/',
    downloadInvoiceUrl: 'configuration-api/get-invoice-pdf/',
    socialMediaUrl: 'configuration-api/social-media-config/',
    getUiDetails: 'configuration-api/default-ui-configuration/'
}

export const adminUrl = {
    bookingDetailsUrl: 'admin-api/court-booking-details/',
    userBookingDetailsUrl: 'admin-api/court-booking-details-filter/',
    userBookingDetailsFilterByIdUrl: 'admin-api/court-booking-details-filter-by-id/',
    filterCourtUrl: 'admin-api/court-venue-sport-filter/',
    getAddonsWithVenueSportListUrl: 'admin-api/venue-sport-addons/',
}

export const PRODUCTION = process.env.REACT_APP_PRODUCTION_VERSION == 'false' ? false : true
export const RazorPayKey = PRODUCTION ? process.env.REACT_APP_RAZORPAY_LIVE_API_KEY : process.env.REACT_APP_RAZORPAY_TEST_API_KEY
export const ApiBaseURL = PRODUCTION ? process.env.REACT_APP_LIVE_BASE_API_URL : process.env.REACT_APP_BASE_API_URL